import { createContext, Dispatch, useReducer } from "react";
import { initialXktState, XktState } from "./XktState";
import { XktActions } from "./Actions";
import xktReducer from "./Reducer";

const XktContext = createContext<{
  state: XktState;
  dispatch: Dispatch<XktActions>;
}>({
  state: initialXktState,
  dispatch: () => undefined,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const XktContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(xktReducer, initialXktState);

  return (
    <XktContext.Provider value={{ state, dispatch }}>
      {children}
    </XktContext.Provider>
  );
};

export { XktContext, XktContextProvider };
